import { RequestBuilder } from '../request_builder'
import { KYC_USER_TYPE } from '@const'

export class UsersRequestBuilder extends RequestBuilder {
  constructor (serverUrl) {
    super(serverUrl)
    this.segment = 'users'
  }

  accountId (accountId) {
    this.filters.push(accountId)
    return this
  }

  documents () {
    this.filters.push('documents')
    return this
  }

  documentId (id) {
    this.filters.push(id)
    return this
  }

  blobs () {
    this.filters.push('blobs')
    return this
  }

  locale () {
    this.filters.push('locale')
    return this
  }

  blobID (id) {
    this.filters.push(id)
    return this
  }

  entities () {
    this.filters.push('entities')
    return this
  }

  entity () {
    this.filters.push('entity')
    return this
  }

  entityID (id) {
    this.filters.push(id)
    return this
  }

  favorites () {
    this.filters.push('favorites')
    return this
  }

  favoriteId (id) {
    this.filters.push(id)
    return this
  }

  taid (id) {
    this.filters.push(id === undefined ? 'taid' : 'taid/' + id)
    return this
  }

  uplataInsha (id) {
    this.filters.push(id === undefined ? 'uplata_insha' : 'uplata_insha/' + id)
    return this
  }
  xpay (id) {
    this.segment = 'xpay/payments_list'
    return this
  }
  cryptoAdress (type) {
    this.segment = 'payments/' + type
    return this
  }
  limit () {
    this.segment = 'user/limits'
    return this
  }
  xpayAddCard () {
    this.segment = 'xpay/add_card'
    return this
  }
  sumsubToken () {
    this.segment = 'sumsub/token'
    return this
  }
  sumsubApplicant (type = 'general') {
    if (type === KYC_USER_TYPE.individual) this.segment = 'sumsub/individual_applicant'
    if (type === KYC_USER_TYPE.company) this.segment = 'sumsub/company_applicant'
    return this
  }
  sumsubApplicantData () {
    this.segment = 'sumsub/applicant_data'
    return this
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/request_builder/modules/users_request_builder.js